var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "person_add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_668_652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.333496,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_668_652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_add_2",
    d: "M36.8335 27.9992V21.4992H30.3335V18.4992H36.8335V11.9992H39.8335V18.4992H46.3335V21.4992H39.8335V27.9992H36.8335ZM18.3335 23.9492C16.1335 23.9492 14.3335 23.2492 12.9335 21.8492C11.5335 20.4492 10.8335 18.6492 10.8335 16.4492C10.8335 14.2492 11.5335 12.4492 12.9335 11.0492C14.3335 9.64922 16.1335 8.94922 18.3335 8.94922C20.5335 8.94922 22.3335 9.64922 23.7335 11.0492C25.1335 12.4492 25.8335 14.2492 25.8335 16.4492C25.8335 18.6492 25.1335 20.4492 23.7335 21.8492C22.3335 23.2492 20.5335 23.9492 18.3335 23.9492ZM2.3335 39.9992V35.2992C2.3335 34.1326 2.62516 33.0742 3.2085 32.1242C3.79183 31.1742 4.6335 30.4659 5.7335 29.9992C8.2335 28.8992 10.4558 28.1242 12.4005 27.6742C14.3452 27.2242 16.3202 26.9992 18.3255 26.9992C20.3308 26.9992 22.3002 27.2242 24.2335 27.6742C26.1668 28.1242 28.3835 28.8992 30.8835 29.9992C31.9835 30.4992 32.8335 31.2159 33.4335 32.1492C34.0335 33.0826 34.3335 34.1326 34.3335 35.2992V39.9992H2.3335ZM5.3335 36.9992H31.3335V35.2992C31.3335 34.7659 31.1835 34.2576 30.8835 33.7742C30.5835 33.2909 30.1835 32.9326 29.6835 32.6992C27.3168 31.5992 25.3168 30.8742 23.6835 30.5242C22.0502 30.1742 20.2668 29.9992 18.3335 29.9992C16.4002 29.9992 14.6085 30.1742 12.9585 30.5242C11.3085 30.8742 9.30016 31.5992 6.9335 32.6992C6.4335 32.9326 6.04183 33.2909 5.7585 33.7742C5.47516 34.2576 5.3335 34.7659 5.3335 35.2992V36.9992ZM18.3335 20.9492C19.6335 20.9492 20.7085 20.5242 21.5585 19.6742C22.4085 18.8242 22.8335 17.7492 22.8335 16.4492C22.8335 15.1492 22.4085 14.0742 21.5585 13.2242C20.7085 12.3742 19.6335 11.9492 18.3335 11.9492C17.0335 11.9492 15.9585 12.3742 15.1085 13.2242C14.2585 14.0742 13.8335 15.1492 13.8335 16.4492C13.8335 17.7492 14.2585 18.8242 15.1085 19.6742C15.9585 20.5242 17.0335 20.9492 18.3335 20.9492Z",
    fill: "#5663F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.d2eacf4fcf4f7f8f6db151c08e0403a5.svg";
export { ForwardRef as ReactComponent };